import { Popover } from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React from 'react';

export const CherryPopover = ({ infoAnchorEl, handleInfoClose, infoRow, theme, sentimentColors }) =>
    <Popover
        open={Boolean(infoAnchorEl)}
        anchorEl={infoAnchorEl}
        onClose={handleInfoClose}

        slotProps={{
            paper: {
                sx: {
                    borderRadius: '8px',
                    boxShadow: 3,
                    overflow: 'hidden',
                }
            }
        }}
        disableRestoreFocus
        className="info-popover"

    >
        {infoRow && (
            <Box
                sx={{
                    p: 2,
                    maxWidth: 350,
                    backgroundColor: theme.palette.background.paper,
                    '& .row': {
                        display: 'flex',
                        borderBottom: `1px solid ${theme.palette.divider}`,
                        '&:last-child': {
                            borderBottom: 'none'
                        }
                    },
                    '& .label': {
                        py: 1,
                        px: 1.5,
                        fontWeight: 'bold',
                        minWidth: '120px',
                        backgroundColor: theme.palette.action.hover,
                        borderRight: `1px solid ${theme.palette.divider}`
                    },
                    '& .value': {
                        py: 1,
                        px: 1.5,
                        flexGrow: 1
                    }
                }}

            >
                <Typography
                    variant="subtitle1"
                    fontWeight="bold"
                    gutterBottom
                    sx={{
                        pb: 1.5,
                        px: 1.5,
                        borderBottom: `2px solid ${theme.palette.primary.main}`,
                        backgroundColor: theme.palette.primary.light,
                        color: theme.palette.primary.contrastText,
                        mx: -2,
                        mt: -2,
                        mb: 1
                    }}
                >
                    Clip Details
                </Typography>

                {infoRow.start_time !== undefined && infoRow.end_time !== undefined && (
                    <Box className="row">
                        <Typography variant="body2" className="label">Time Range</Typography>
                        <Typography variant="body2" className="value">
                            {infoRow.start_time}s - {infoRow.end_time}s
                        </Typography>
                    </Box>
                )}

                {infoRow.sentiment && (
                    <Box className="row">
                        <Typography variant="body2" className="label">Sentiment</Typography>
                        <Typography variant="body2" className="value" sx={{
                            color: sentimentColors[infoRow.sentiment] || sentimentColors.default,
                            fontWeight: 'medium'
                        }}>
                            {infoRow.sentiment.charAt(0).toUpperCase() + infoRow.sentiment.slice(1)}
                        </Typography>
                    </Box>
                )}

                {infoRow.verbs && (
                    <Box className="row">
                        <Typography variant="body2" className="label">Verbs</Typography>
                        <Typography variant="body2" className="value">
                            {Array.isArray(infoRow.verbs) ? infoRow.verbs.join(', ') : infoRow.verbs}
                        </Typography>
                    </Box>
                )}

                {infoRow.adjectives && (
                    <Box className="row">
                        <Typography variant="body2" className="label">Adjectives</Typography>
                        <Typography variant="body2" className="value">
                            {Array.isArray(infoRow.adjectives) ? infoRow.adjectives.join(', ') : infoRow.adjectives}
                        </Typography>
                    </Box>
                )}

                {infoRow.nouns && (
                    <Box className="row">
                        <Typography variant="body2" className="label">Nouns</Typography>
                        <Typography variant="body2" className="value">
                            {Array.isArray(infoRow.nouns) ? infoRow.nouns.join(', ') : infoRow.nouns}
                        </Typography>
                    </Box>
                )}

                {/* Show any other properties that might be in the data */}
                {Object.entries(infoRow).map(([key, value]) => {
                    // Skip the properties we've already handled and common ones we don't need to show
                    const skipProps = ['start_time', 'end_time', 'seconds_length', 'sentiment',
                        'verbs', 'adjectives', 'nouns', 'id', 'thumbnail', 'sentence',
                        'space', 'order', 'duration', 'question'];

                    if (skipProps.includes(key) || typeof value === 'object' || typeof value === 'function' || value === null || value === undefined) {
                        return null;
                    }

                    return (
                        <Box key={key} className="row">
                            <Typography variant="body2" className="label">
                                {key.charAt(0).toUpperCase() + key.slice(1).replace(/_/g, ' ')}
                            </Typography>
                            <Typography variant="body2" className="value">{value}</Typography>
                        </Box>
                    );
                })}
            </Box>
        )}
    </Popover>
